import { createContext, useContext } from 'react';
export const ClientContext = createContext(null);
export const ClientProvider = ClientContext.Provider;
export function useClient() {
    return useContext(ClientContext);
}
